import { Box, BoxProps } from "@mui/material"
import React from "react"

type LogoProps = React.SVGProps<SVGSVGElement> &
  BoxProps & {
    loading?: boolean
  }

export function Logo(props: LogoProps) {
  const { loading = false, ...rest } = props

  return (
    <Box
      component="svg"
      width={40}
      height={40}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-25 -25 551 551"
      className={loading ? "loading-indicator-active" : ""}
      // color="var(--mui-palette-primary-main)"
      {...rest}
    >
      <path
        fill="currentColor"
        d="m495.5,200.5c-3.53-17.39-8.86-34.12-15.8-50-7.8-17.85-17.62-34.62-29.18-50-.01-.01-.01-.02-.02-.03-14.22-18.92-31.05-35.75-49.97-49.97-.01-.01-.02-.01-.03-.02-15.38-11.56-32.15-21.38-50-29.18-15.88-6.94-32.61-12.27-50-15.8-16.16-3.28-32.88-5-50-5s-33.84,1.72-50,5c-17.39,3.53-34.12,8.86-50,15.8-17.85,7.8-34.62,17.62-50,29.18-.01.01-.02.01-.03.02-18.92,14.22-35.75,31.05-49.97,49.97-.01.01-.01.02-.02.03-11.56,15.38-21.38,32.15-29.18,50-6.94,15.88-12.27,32.61-15.8,50-3.28,16.16-5,32.88-5,50s1.72,33.84,5,50c3.53,17.39,8.86,34.12,15.8,50,7.8,17.85,17.62,34.62,29.18,50,.01.01.01.02.02.03,14.22,18.92,31.05,35.75,49.97,49.97.01.01.02.01.03.02,15.38,11.56,32.15,21.38,50,29.18,15.88,6.94,32.61,12.27,50,15.8,16.16,3.28,32.88,5,50,5s33.84-1.72,50-5c17.39-3.53,34.12-8.86,50-15.8,17.85-7.8,34.62-17.62,50-29.18.01,0,.02,0,.03-.02,18.92-14.22,35.75-31.05,49.97-49.97.01-.01.01-.02.02-.03,11.56-15.38,21.38-32.15,29.18-50,6.94-15.88,12.27-32.61,15.8-50,3.28-16.16,5-32.88,5-50s-1.72-33.84-5-50Zm-169.25,0v125.75h-151.5v-151.5h151.5v25.75Z"
        strokeWidth={5}
        stroke="currentColor"
      />
    </Box>
  )
}
